import { render, staticRenderFns } from "./EmailPositionApplicant.vue?vue&type=template&id=13c079d6&scoped=true"
import script from "./EmailPositionApplicant.vue?vue&type=script&lang=js"
export * from "./EmailPositionApplicant.vue?vue&type=script&lang=js"
import style0 from "./EmailPositionApplicant.vue?vue&type=style&index=0&id=13c079d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c079d6",
  null
  
)

export default component.exports